import React, { useState } from 'react';
import useSSE from './useSSE';
// import useHeartbeat from './useHeartbeat';

type SSEListenerProps = {
  sessionId: string | null;
  // isConnected: boolean;
  // setIsConnected: boolean;
};

const SSEListener: React.FC<SSEListenerProps> = ({ sessionId }) => {
  const [message, setMessage] = useState('No heartbeat yet');
  const [isConnected, setIsConnected] = useState(false);

  useSSE(sessionId);  // useSSE hook'u çağırıyoruz

  // useHeartbeat(sessionId, setMessage => { }, setIsConnected=>{});

  return null; // Bu bileşen JSX döndürmüyor, sadece side-effect için kullanılıyor
};

export default SSEListener;
